var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Suspense } from "react";
import HTMLRender from "../html-render/html-render";
import { Portal } from "../portal/portal";
var AppRenderer = function (_a) {
    var components = _a.components;
    return (React.createElement(React.Fragment, null, Object.entries(components).map(function (_a) {
        var dataType = _a[0], Component = _a[1];
        var componentWrappers = Array.from(document.querySelectorAll("[data-type=\"" + dataType + "\"]"));
        return (React.createElement(React.Fragment, null, componentWrappers.map(function (wrapper, index) {
            var _a;
            var props = JSON.parse((_a = wrapper.dataset.props) !== null && _a !== void 0 ? _a : "{}");
            wrapper.removeAttribute("data-props");
            return (React.createElement(Portal, { key: index, wrapper: wrapper },
                React.createElement(Suspense, { fallback: React.createElement(HTMLRender, { html: wrapper.innerHTML }) },
                    React.createElement(Component, __assign({ InnerHTML: function () { return React.createElement(HTMLRender, { html: wrapper.innerHTML }); } }, props)))));
        })));
    })));
};
export default AppRenderer;
